import permissions from '../../data/permissions';

export default [
    {
        name: "PurchasePaymentCreate",
        path: "payment",
        component: () => import('./../../views/purchase/PurchasePaymentCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment.create }
    },
    {
        name: "PurchasePaymentDisplay",
        path: "payment/:id",
        component: () => import('./../../views/purchase/PurchasePaymentDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment.read }
    },
    {
        name: "PurchasePaymentEdit",
        path: "payment/:id/edit",
        component: () => import('./../../views/purchase/PurchasePaymentEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment.update }
    },
    {
        name: "PurchasePaymentList",
        path: "payments",
        component: () => import('./../../views/purchase/PurchasePaymentListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.payment.index }
    }
];